import React from 'react';
import './scss/main.scss';
import CIcon from '@coreui/icons-react';
import {
  cilBell,
  cilCalculator,
  cilCalendar,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
  cilSettings,
  cilChatBubble,
  cilLibrary,
  cilHome,
  cilMediaPlay,
} from '@coreui/icons';
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react';
import { NavLink } from 'react-router-dom';

const getNavItems = (handleNavClick) => [
  {
    component: CNavItem,
    name: 'MiEROS Org',

    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    to: '#', // Add a dummy link to preserve styling

    onClick: (e) => {
      e.preventDefault(); // Prevents the dummy link from doing anything
      window.open('https://mieros.org/', '_blank'); // Opens the link in a new tab

    },
  },
  // {
  //   component: CNavTitle,
  //   name: 'Theme',
  // },
  // {
  //   component: CNavItem,
  //   name: 'MiE NFT',
  //   to: '#', // Add a dummy link to preserve styling
  //   icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  //   onClick: (e) => {
  //     e.preventDefault(); // Prevents the dummy link from doing anything
  //     window.open('https://mint.mieros.cloud/', '_blank'); // Opens the link in a new tab

  //   },
  // },
  {
    component: CNavItem,
    name: 'MiEROS Wiki',
    to: '#', // Add a dummy link to preserve styling
    icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
    onClick: (e) => {
      e.preventDefault(); // Prevents the dummy link from doing anything
      window.open('https://github.com/MiEROS-LLC/MiEROS-Wiki/wiki', '_blank'); // Opens the link in a new tab

    },
  },
  // {
  //   component: CNavItem,
  //   name: 'MiE Data',
  //   to: 'https://fhir.mieros.cloud/?serverId=home&pretty=true&_summary=&resource=',
  //   icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
  //   onClick: () => handleNavClick('scheduler'),
  // },
  {
    component: CNavTitle,
    name: 'Devices',
  },
  {
    component: CNavGroup,
    name: 'Devices',
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'IoT Hub',
        to: '/dashboard/iot',
        icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: 'PiBots',
        to: '/dashboard/iot/pibots',
        icon: <CIcon icon={cilMediaPlay} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'AI Agents',
  },
  {
    component: CNavGroup,
    name: 'Agents',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    attributes: { 'data-tour': 'ai-agents' }, // used by FeatureTour
    items: [
      {
        component: CNavItem,
        name: 'My Agents',
        to: '/dashboard/agents',
      },
      {
        component: CNavItem,
        name: 'Create Agent',
        to: '/dashboard/agents/new',
      },
      {
        component: CNavItem,
        name: 'My Profile',
        to: '/dashboard/profile/agent',
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'Extras',
  },
 
];

export default getNavItems;
